/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The QuestionInputDto model module.
 * @module model/QuestionInputDto
 * @version v0
 */
class QuestionInputDto {
    /**
     * Constructs a new <code>QuestionInputDto</code>.
     * Question object to create
     * @alias module:model/QuestionInputDto
     * @param content {String} 
     * @param difficulty {Number} 
     */
    constructor(content, difficulty) { 
        
        QuestionInputDto.initialize(this, content, difficulty);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, content, difficulty) { 
        obj['content'] = content;
        obj['difficulty'] = difficulty;
    }

    /**
     * Constructs a <code>QuestionInputDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/QuestionInputDto} obj Optional instance to populate.
     * @return {module:model/QuestionInputDto} The populated <code>QuestionInputDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new QuestionInputDto();

            if (data.hasOwnProperty('content')) {
                obj['content'] = ApiClient.convertToType(data['content'], 'String');
            }
            if (data.hasOwnProperty('interpretation')) {
                obj['interpretation'] = ApiClient.convertToType(data['interpretation'], 'String');
            }
            if (data.hasOwnProperty('difficulty')) {
                obj['difficulty'] = ApiClient.convertToType(data['difficulty'], 'Number');
            }
            if (data.hasOwnProperty('page_id')) {
                obj['page_id'] = ApiClient.convertToType(data['page_id'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>QuestionInputDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>QuestionInputDto</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of QuestionInputDto.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['content'] && !(typeof data['content'] === 'string' || data['content'] instanceof String)) {
            throw new Error("Expected the field `content` to be a primitive type in the JSON string but got " + data['content']);
        }
        // ensure the json data is a string
        if (data['interpretation'] && !(typeof data['interpretation'] === 'string' || data['interpretation'] instanceof String)) {
            throw new Error("Expected the field `interpretation` to be a primitive type in the JSON string but got " + data['interpretation']);
        }

        return true;
    }


}

QuestionInputDto.RequiredProperties = ["content", "difficulty"];

/**
 * @member {String} content
 */
QuestionInputDto.prototype['content'] = undefined;

/**
 * @member {String} interpretation
 */
QuestionInputDto.prototype['interpretation'] = undefined;

/**
 * @member {Number} difficulty
 */
QuestionInputDto.prototype['difficulty'] = undefined;

/**
 * @member {Number} page_id
 */
QuestionInputDto.prototype['page_id'] = undefined;






export default QuestionInputDto;

